<template>
    <v-dialog v-model="dialog" width="1080px" max-width="85%">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small text>
                <v-icon small class="mr-1">{{ mdiFileDocumentMultipleOutline }}</v-icon>
                {{ _applications.length }}건
            </v-btn>
        </template>

        <v-card>
            <application-list-title :program="program" @close="dialog = false" />
            <v-card-text class="pt-5">
                <v-data-table v-if="!$data._application" :headers="headers" :items="applications">
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn icon @click="$data._application = item._id">
                            <v-icon small>mdi-file-document</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                <template v-else>
                    <application-view :_application="$data._application" :disabled="!modify" />
                </template>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <template v-if="!$data._application">
                    <v-spacer />
                    <v-col cols="auto">
                        <button-tile color="green" @click="excel">
                            <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>
                            엑셀다운로드
                        </button-tile>
                    </v-col>
                </template>
                <template v-else>
                    <v-col cols="auto">
                        <button-tile content="리스트" @click="reset" color="grey darken-1" />
                    </v-col>
                    <v-spacer />
                    <v-col v-show="false" cols="auto">
                        <template v-if="!modify">
                            <button-tile content="수정" color="blue" @click="modify = !modify" />
                            <button-tile content="삭제" color="red" class="ml-4" />
                        </template>
                        <template v-else>
                            <button-tile content="삭제" color="red" class="ml-4" />
                            <v-btn dark depressed tile color="blue darken-2">수정</v-btn>
                        </template>
                    </v-col>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import dayjs from "dayjs";
import { mdiMicrosoftExcel, mdiFileDocumentMultipleOutline } from "@mdi/js";

import ButtonTile from "../dumb/button-tile.vue";
import ApplicationView from "./application-view.vue";
import ApplicationListTitle from "./application-list-title.vue";

export default {
    components: {
        ButtonTile,
        ApplicationView,
        ApplicationListTitle,
    },
    props: ["program"],
    computed: {
        _applications() {
            return this.program._applications;
        },
        headers() {
            return [
                { text: "아이디", value: "user.username" },
                { text: "회사명", value: "applicant.companyName" },
                { text: "담당자 / 직책", value: "applicant.worker" },
                { text: "연락처", value: "applicant.phone" },
                { text: "이메일", value: "applicant.email" },
                { text: "", value: "actions" },
            ];
        },
    },
    data() {
        return {
            dialog: false,
            modify: false,

            applications: [],
            _application: null,

            mdiMicrosoftExcel,
            mdiFileDocumentMultipleOutline,
        };
    },
    methods: {
        reset() {
            this.$data._application = null;
            this.modify = false;
        },
        async search() {
            try {
                const { applications } = await api.console.services.applications.gets({ _program: this.program._id });
                this.applications = applications;
            } catch (error) {
                this.$handleError(error);
            }
        },

        async excel() {
            try {
                const { program } = this;
                const formattedData = this.applications.map(({ applicant, createdAt }) => ({
                    신청일시: createdAt?.toDateTime?.() || "-",
                    신청서비스명: program?.title || "-",
                    기업명: applicant?.companyName || "-",
                    대표자명: applicant?.ceoName || "-",
                    사업자등록번호: applicant?.businessNumber || "-",
                    기업설립일: applicant?.establishedAt?.toDate?.() || "-",
                    연락처: applicant?.phone || "-",
                    이메일: applicant?.email || "-",
                    소재지: `[${applicant?.postcode}] ${applicant?.address1} ${applicant?.address2}`,
                    홈페이지주소: applicant?.website || "-",
                    "신청자 / 직책": applicant?.worker || "-",
                    주요생산제품: applicant?.mainProduct || "-",
                }));
                const workbook = new XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(formattedData);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, `지원현황${dayjs().format("YYMMDDHHmmss")} - [${this.program.categoryName}] ${this.program.title}.xlsx`);
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        dialog() {
            this.search();
        },
    },
};
</script>

<style></style>
